import { Button, Card, CardContent, CardHeader, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, Slide, TextField, Tooltip, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { IconCircleX, IconInfoCircleFilled } from "@tabler/icons-react";
import { IconAdjustmentsHorizontal, IconX } from "@tabler/icons-react";
import { removeEmptyKeys } from "helper/encodeData";
import React, { forwardRef, useEffect, useState, } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { getCustomerOption } from "store/app/farm-management/farm-records/actions";
import { setLabRecordsFilteredData } from "store/app/lab-management/lab-records/actions";
import { useTheme } from "@emotion/react";
import { useSearchParams } from "react-router-dom";

const styles = {
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
        display: "none",
    },
    "& input[type=number]": {
        MozAppearance: "textfield",
    },
}
const Transition = forwardRef((props, ref) => <Slide direction="left" ref={ref} {...props} />);

const FilterLabRecords = (props) => {

    const { open, onClose, labRecordsFilterData } = props;

    const [filter, setFilter] = useState();
    const [errors, setErrors] = useState();

    const theme = useTheme();
    const [searchParams, setSearchParmas] = useSearchParams();
    const filterObject = Object.fromEntries([...searchParams.entries()].map(([key, value]) => [
        key?.toLowerCase(),
        value?.toLowerCase(),
    ]));

    useEffect(() => {
        if (labRecordsFilterData) {
            setFilter(labRecordsFilterData);
        }
        else {
            setFilter(null);
        }
    }, [open]);

    const validateOnchange = (e) => {
        const { name, value } = e.target;
        setFilter({
            ...filter,
            [name]: value,
        });
    }

    const validateOnDate = (name, date) => {
        const formattedDate = date ? moment(date).format("DD-MM-YYYY") : null;
        setFilter({
            ...filter,
            [name]: formattedDate,
        });
        setErrors({
            ...errors,
            [name]: null,
        })
    }

    const updateIfDifferent = (filterObj, paramsObj) => {
        let updated = false;
        for (const key of Object.keys(paramsObj)) {
            if (key in filterObj && paramsObj[key] !== filterObj[key]) {
                paramsObj[key] = filterObj[key];
                updated = true;
            }
        }

        return updated ? { ...paramsObj } : paramsObj;
    }

    const handleFilter = (e) => {
        e.preventDefault();
        const { fromdate, todate, submittedfrom, submittedto } = filter || {};
        let currentErrors = {};
        if (fromdate) {
            if (fromdate === "Invalid date") {
                currentErrors.fromdate = "From date is invalid";
            }
            if (!todate) {
                currentErrors.todate = "To date is required";
            }
        }
        if (todate) {
            if (todate === "Invalid date") {
                currentErrors.todate = "To date is invalid";
            }
            if (!fromdate) {
                currentErrors.fromdate = "From date is required";
            }
        }
        if (submittedfrom) {
            if (submittedfrom === "Invalid date") {
                currentErrors.submittedfrom = "From date is invalid";
            }
            if (!submittedto) {
                currentErrors.submittedto = "To date is required";
            }
        }
        if (submittedto) {
            if (submittedto === "Invalid date") {
                currentErrors.submittedto = "To date is invalid";
            }
            if (!submittedfrom) {
                currentErrors.submittedfrom = "From date is required";
            }
        }

        setErrors(currentErrors);
        if (Object.keys(currentErrors).length === 0) {
            onClose();

            const nonEmptyData = removeEmptyKeys(filter);
            const paramsKey = filterObject ? Object.keys(filterObject) : [];
            const missingKey = paramsKey.filter(key => !(key in nonEmptyData));
            missingKey?.map((key) => delete filterObject[key]);
            if (filterObject?.src) {
                delete filterObject.src;
            }
            const compareFilter = (nonEmptyData && filterObject) ? updateIfDifferent({ ...nonEmptyData }, { ...filterObject }) : {};
            setSearchParmas(compareFilter);
            props.setLabRecordsFilteredData(nonEmptyData);
            onClose();
        }
    }

    const handleFilterClear = (e) => {
        e.preventDefault();
        onClose();
        props.setLabRecordsFilteredData();
        setSearchParmas();
    }

    const validateClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }
    return (
        <>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                maxWidth={'md'}
                fullWidth
                keepMounted
                onClose={validateClose}
                sx={{
                    '&>div:nth-of-type(3)': {
                        justifyContent: 'flex-end',
                        '&>div': {
                            m: 0,
                            borderRadius: '10px 0px 0px 10px',
                            maxWidth: 650,
                            maxHeight: '100%'
                        }
                    }
                }}
            >
                {open && (
                    <>
                        <Card sx={{ overflow: 'auto' }} >
                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", pt: 0, pb: 0 }}>
                                Filters
                                <IconButton
                                    aria-label="close"
                                    onClick={onClose}
                                >
                                    <IconX />
                                </IconButton>
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                <form>
                                    <Grid container rowGap={4} marginTop={2}>
                                        <Grid container rowGap={4} columnSpacing="16" direction={'row'}  >
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    autoFocus
                                                    sx={styles}
                                                    label="Lab Record No."
                                                    fullWidth
                                                    size="small"
                                                    name='labrecordsno'
                                                    type='number'
                                                    onKeyDown={
                                                        (e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
                                                    }
                                                    onChange={validateOnchange}
                                                    value={filter?.labrecordsno}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    label="Report Name"
                                                    fullWidth
                                                    size="small"
                                                    name='reportname'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.reportname}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    sx={styles}
                                                    label="Farm Record No."
                                                    fullWidth
                                                    size="small"
                                                    name='farmrecordsno'
                                                    type='number'
                                                    onKeyDown={
                                                        (e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
                                                    }
                                                    onChange={validateOnchange}
                                                    value={filter?.farmrecordsno}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    label="Farm Name"
                                                    fullWidth
                                                    size="small"
                                                    name='farmname'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.farmname}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    label="Observation"
                                                    fullWidth
                                                    size="small"
                                                    name='observation'
                                                    type='text'
                                                    multiline
                                                    onChange={validateOnchange}
                                                    value={filter?.observation}
                                                />
                                            </Grid>
                                            <Grid item lg={12} md={12} sm={12}>
                                                <Card sx={{ border: `2px solid ${theme.palette.primary.light}`, pt: 1 }}>
                                                    <CardHeader
                                                        sx={{ p: 1 }}
                                                        title={
                                                            <Grid item sx={{ display: "flex", justifyContent: "space-between" }}>
                                                                <Typography variant="inherit" sx={{ fontWeight: "500", fontSize: "17px" }}>
                                                                    Inspection Date
                                                                </Typography>
                                                                <Tooltip title="Inspection date filter need both from and to date." placement="top" arrow>
                                                                    <IconInfoCircleFilled style={{ color: "gray", cursor: "pointer" }} />
                                                                </Tooltip>
                                                            </Grid>
                                                        }
                                                    />
                                                    <CardContent sx={{ p: 1, pt: 1 }}>
                                                        <Grid container columnSpacing="16">
                                                            <Grid item lg={6} md={6} sm={12}>
                                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                                    <DatePicker
                                                                        label="From Date"
                                                                        onChange={(date) => validateOnDate("inspectedfrom", date)}
                                                                        fullWidth
                                                                        format="DD/MM/YYYY"
                                                                        value={filter?.inspectedfrom ? moment.utc(filter.inspectedfrom, "DD-MM-YYYY") : null}
                                                                        maxDate={filter?.inspectedto ? moment.utc(filter.inspectedto, "DD-MM-YYYY") : null}
                                                                        slotProps={{
                                                                            textField: {
                                                                                size: "small",
                                                                                fullWidth: true,
                                                                                error: errors?.inspectedfrom,
                                                                                helperText: errors?.inspectedfrom
                                                                            },
                                                                            field: { clearable: true },
                                                                        }}
                                                                    />
                                                                </LocalizationProvider>
                                                            </Grid>
                                                            <Grid item lg={6} md={6} sm={12}>
                                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                                    <DatePicker
                                                                        label="To Date"
                                                                        onChange={(date) => validateOnDate("inspectedto", date)}
                                                                        fullWidth
                                                                        format="DD/MM/YYYY"
                                                                        value={filter?.inspectedto ? moment.utc(filter.inspectedto, "DD-MM-YYYY") : null}
                                                                        minDate={filter?.inspectedfrom ? moment.utc(filter.inspectedfrom, "DD-MM-YYYY") : null}
                                                                        slotProps={{
                                                                            textField: {
                                                                                size: "small",
                                                                                fullWidth: true,
                                                                                error: errors?.inspectedto,
                                                                                helperText: errors?.inspectedto
                                                                            },
                                                                            field: { clearable: true },
                                                                        }}
                                                                    />
                                                                </LocalizationProvider>
                                                            </Grid>
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                            <Grid item lg={12} md={12} sm={12}>
                                                <Card sx={{ border: `2px solid ${theme.palette.primary.light}`, pt: 1 }}>
                                                    <CardHeader
                                                        sx={{ p: 1 }}
                                                        title={
                                                            <Grid item sx={{ display: "flex", justifyContent: "space-between" }}>
                                                                <Typography variant="inherit" sx={{ fontWeight: "500", fontSize: "17px" }}>
                                                                    Record Submitted Date
                                                                </Typography>
                                                                <Tooltip title="Record sumbitted date filter need both from and to date." placement="top" arrow>
                                                                    <IconInfoCircleFilled style={{ color: "gray", cursor: "pointer" }} />
                                                                </Tooltip>
                                                            </Grid>
                                                        }
                                                    />
                                                    <CardContent sx={{ p: 1, pt: 1 }}>
                                                        <Grid container columnSpacing="16">
                                                            <Grid item lg={6} md={6} sm={12}>
                                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                                    <DatePicker
                                                                        label="From Date"
                                                                        onChange={(date) => validateOnDate("submittedfrom", date)}
                                                                        fullWidth
                                                                        format="DD/MM/YYYY"
                                                                        value={filter?.submittedfrom ? moment.utc(filter.submittedfrom, "DD-MM-YYYY") : null}
                                                                        maxDate={filter?.submittedto ? moment.utc(filter.submittedto, "DD-MM-YYYY") : null}
                                                                        slotProps={{
                                                                            textField: {
                                                                                size: "small",
                                                                                fullWidth: true,
                                                                                error: errors?.submittedfrom,
                                                                                helperText: errors?.submittedfrom
                                                                            },
                                                                            field: { clearable: true },
                                                                        }}
                                                                    />
                                                                </LocalizationProvider>
                                                            </Grid>
                                                            <Grid item lg={6} md={6} sm={12}>
                                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                                    <DatePicker
                                                                        label="To Date"
                                                                        onChange={(date) => validateOnDate("submittedto", date)}
                                                                        fullWidth
                                                                        format="DD/MM/YYYY"
                                                                        value={filter?.submittedto ? moment.utc(filter.submittedto, "DD-MM-YYYY") : null}
                                                                        minDate={filter?.submittedfrom ? moment.utc(filter.submittedfrom, "DD-MM-YYYY") : null}
                                                                        slotProps={{
                                                                            textField: {
                                                                                size: "small",
                                                                                fullWidth: true,
                                                                                error: errors?.submittedto,
                                                                                helperText: errors?.submittedto
                                                                            },
                                                                            field: { clearable: true },
                                                                        }}
                                                                    />
                                                                </LocalizationProvider>
                                                            </Grid>
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    label="Technical Manager Name"
                                                    fullWidth
                                                    size="small"
                                                    name='technicalmanagerusername'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.technicalmanagerusername}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    label="Technical Manager Email"
                                                    fullWidth
                                                    size="small"
                                                    name='technicalmanageruseremail'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.technicalmanageruseremail}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    label="Customer Name"
                                                    fullWidth
                                                    size="small"
                                                    name='customername'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.customername}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    label="Customer Email"
                                                    fullWidth
                                                    size="small"
                                                    name='customeremail'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.customeremail}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    label="Submitted User Name"
                                                    fullWidth
                                                    size="small"
                                                    name='submittedusername'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.submittedusername}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    label="Submitted User Email"
                                                    sx={styles}
                                                    fullWidth
                                                    size="small"
                                                    name='submitteduseremail'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.submitteduseremail}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    label="Location"
                                                    sx={styles}
                                                    fullWidth
                                                    size="small"
                                                    name='location'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.location}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    label="Region Name"
                                                    sx={styles}
                                                    fullWidth
                                                    size="small"
                                                    name='regionname'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.regionname}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    label="State/Export"
                                                    sx={styles}
                                                    fullWidth
                                                    size="small"
                                                    name='state'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.state}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    label="District"
                                                    sx={styles}
                                                    fullWidth
                                                    size="small"
                                                    name='district'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.district}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    label="Anticoccidial"
                                                    sx={styles}
                                                    fullWidth
                                                    size="small"
                                                    name='anticoccidial'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.anticoccidial}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    label="Agp"
                                                    sx={styles}
                                                    fullWidth
                                                    size="small"
                                                    name='agp'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.agp}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    label="Probiotic"
                                                    sx={styles}
                                                    fullWidth
                                                    size="small"
                                                    name='probiotic'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.probiotic}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container justifyContent={'right'}>
                                            <Button
                                                variant="contained"
                                                onClick={handleFilter}
                                                size="small"
                                                color="primary"
                                                startIcon={<IconAdjustmentsHorizontal />}
                                            >
                                                Apply Filters
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={handleFilterClear}
                                                sx={{ ml: 2 }}
                                                color='error'
                                                size="small"
                                                startIcon={<IconCircleX />}
                                            >
                                                Clear
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                        </Card>
                    </>
                )}
            </Dialog >
        </>
    )
}

const mapStateToProps = (state) => ({
    labRecordsFilterData: state.labRecords.labRecordsFilterData,
})
const mapDispatchToProps = (dispatch) => ({
    setLabRecordsFilteredData: (filter) => dispatch(setLabRecordsFilteredData(filter)),
    getCustomerOption: (filter) => dispatch(getCustomerOption(filter)),
})

export default connect(mapStateToProps, mapDispatchToProps)(FilterLabRecords);